// extracted by mini-css-extract-plugin
module.exports = {"name":"TeamCard_name__2Sku0","lastRow":"TeamCard_lastRow__1Kw-G"};